const isValidTimeFormat = (textString) => {
	const maybeMatch = textString.match(/^\d{2}\:\d{2}\:\d{2}$/g);

	return maybeMatch !== null;
}

module.exports = isValidTimeFormat